import { render, staticRenderFns } from "./MenuForm.vue?vue&type=template&id=c69125c8&"
import script from "./MenuForm.vue?vue&type=script&lang=js&"
export * from "./MenuForm.vue?vue&type=script&lang=js&"
import style0 from "./MenuForm.vue?vue&type=style&index=0&id=c69125c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports